<div class="relative flex shrink-0" (click)="onDialogClick()">
  <h2 class="typo-h2 ml-2">{{ 'health_history_title' | translate }}</h2>
  <button class="absolute right-2 top-0" (click)="closeDialog()">
    <svg-icon class="text-text-primary" key="px-24-x" size="md"></svg-icon>
  </button>
</div>

<div class="grid h-full min-h-0 grid-cols-[360px_auto] grid-rows-[auto_1fr] gap-4" (click)="onDialogClick()">
  <lib-health-history-patient-details #patientDetails />
  <lib-health-history-list
    class="row-span-2 overflow-hidden"
    [initialActiveTabIndex]="dialogData.activeTabIndex ?? 0"
  ></lib-health-history-list>
  <lib-health-history-notes
    #healthHistoryNotesComponent
    class="row-start-2 overflow-hidden"
    (click)="onPatientNotesClick($event)"
    (noteClicked)="onPatientNotesClick()"
  ></lib-health-history-notes>
</div>
